<template>
  <path
    d="M20 6.00024H12L10.59 4.59024C10.21 4.21024 9.7 4.00024 9.17 4.00024H4C2.9 4.00024 2.01 4.90024 2.01 6.00024L2 18.0002C2 19.1002 2.9 20.0002 4 20.0002H20C21.1 20.0002 22 19.1002 22 18.0002V8.00024C22 6.90024 21.1 6.00024 20 6.00024ZM15 9.00024C16.1 9.00024 17 9.90024 17 11.0002C17 12.1002 16.1 13.0002 15 13.0002C13.9 13.0002 13 12.1002 13 11.0002C13 9.90024 13.9 9.00024 15 9.00024ZM19 17.0002H11V16.0002C11 14.6702 13.67 14.0002 15 14.0002C16.33 14.0002 19 14.6702 19 16.0002V17.0002Z"
  />
</template>
